<template>
    <div class="main-center" style="margin-top: 95px;">
        <iframe id="reportFrame" width="100%" height="1248px" frameborder="0" scrolling="auto"
                :src="fr_cpt_url">
        </iframe>
        <div class="footerSpan">
            <span></span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ladingPreview",
        data() {
            return {
                fr_cpt_url: "",
            }
        },
        methods: {
            initData() {
                // if (this.$route.params == null) {
                //     return;
                // }
                // if (this.$route.params.fr_cpt_url == null) {
                //     return;
                // }
                // this.fr_cpt_url = this.$route.params.fr_cpt_url;
                if(sessionStorage.getItem("PASSING_PARAMETERS") == null){
                    return;
                }
                this.fr_cpt_url = sessionStorage.getItem("PASSING_PARAMETERS");
            }
        },
        created() {
            this.initData();
            this.$parent.updateHeaderAside();
        }
    }
</script>

<style scoped>

</style>